import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import displayError from '../../utils/ErrorHandler';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';

const ListItems = () => {
  const [items, setItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [message,setMessage] = useState('')
  const navigate = useNavigate();
  const {user,setUser} = useContext(UserContext)
  const [loading, setLoading] = useState(false);

  const requestPage = () => {
    navigate("/add-item");
  };

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  useEffect(() => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_URI}/api/items/getAll`, { withCredentials: true })
      .then(response => {
        setLoading(false);
        const initialItems = response.data.data.map(item => ({ ...item, quantity: 0 }));
        setItems(initialItems);
      })
      .catch((err) => {
        setLoading(false);
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
      })
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const getBadgeClass = (purchaseType) => {
    switch (purchaseType) {
      case 'zone':
        return 'bg-blue-500 text-blue-100';
      case 'central':
        return 'bg-teal-600 text-teal-100';
      default:
        return 'bg-blue-500 text-blue-100'; // Default color if purchaseType is not recognized
    }
  };

  const filteredItems = items.filter(item =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>

    {loading ? (
      <div className='flex justify-center items-center h-[70vh] w-full'>
           <p>Loading Please Wait...</p>
         </div>
    ) : (
      <div className="p-4">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
      <div className="mb-4">
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-fmb"
          placeholder="Search items..."
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredItems.map(item => (
          <div key={item._id} className="bg-white p-4 rounded-lg shadow-md border border-fmb-light flex justify-between items-center">
            <div>
              <h2 className="text-lg font-semibold text-fmb">{item.name}</h2>
              <div className="text-sm text-gray-700">
                <span className="mr-2">{item.category}</span>
                <span>{item.unit}</span>
              </div>
            </div>
            {item.purchaseType && (
              <div className={`text-sm font-medium px-3 py-1 rounded-full ${getBadgeClass(item.purchaseType)}`}>
                {item.purchaseType}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="fab-container" onClick={requestPage}>
          <button className="fab-button bg-fmb">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
          <span className="fab-text text-fmb">Add New Item</span>
        </div>
    </div>
    )}

    </>
  );
};

export default ListItems;